import Link from 'next/link'
import { LogoutModal } from './LogoutModal'
import { useUser } from './User'
import { useCart } from './Cart'

function NavbarDesktop({ items }) {
    return (
        <>
            <nav className="hidden lg:block">
                <ul className="flex items-center justify-between px-8 space-s-6 pt-2 ">
                    {items.map((item, idx) => (
                        <li key={idx}>
                            {item.children && item.children.length !== 0 && <MenuBody item={item} />}

                            {(!item.children || item.children.length == 0) && (
                                <Link href={item.href || ''}>
                                    <a className="no-underline">{item.title}</a>
                                </Link>
                            )}
                        </li>
                    ))}
                </ul>
            </nav>
        </>
    )
}

function NavbarMobile() {
    const user = useUser()
    const cart = useCart()

    return (
        <div className="bg-white flex justify-between z-50 fixed inset-x-0 bottom-0 lg:hidden  shadow-inner px-5 md:px-10" style={{transform: 'translate3d(0,0,0)'}}>
            <Link href="/">
                <a className="flex flex-col h-20 text-center  p-2">
                    <svg
                        className="w-8  mb-1 mx-auto text-purple-300"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                        />
                    </svg>
                    <span className="text-gray-400 text-xs">خانه</span>
                </a>
            </Link>
            <Link href="/products/list">
                <a className="flex flex-col h-20 text-center  p-2">
                    <svg
                        className="w-8  mb-1 mx-auto text-purple-300"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10"
                        />
                    </svg>
                    <span className="text-gray-400 text-xs">محصولات</span>
                </a>
            </Link>
            {user.isLoggedIn && (
                <Link href="/profile">
                    <a className="flex flex-col h-20 text-center  p-2">
                        <svg
                            className="w-8  mb-1 mx-auto text-purple-300"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                            />
                        </svg>
                        <span className="text-gray-400 text-xs">پروفایل</span>
                    </a>
                </Link>
            )}
            {!user.isLoggedIn && (
                <Link href="/auth/signin">
                    <a className="flex flex-col h-20 text-center  p-2">
                        <svg
                            className="w-8  mb-1 mx-auto text-purple-300"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor">
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                            />
                        </svg>
                        <span className="text-gray-400 text-xs">ورود و ثبت نام</span>
                    </a>
                </Link>
            )}
            <Link href="/cart">
                <a className="flex flex-col h-20 text-center  p-2">
                    <svg
                        className="w-8  mb-1 mx-auto text-purple-300"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
                    </svg>
                    <span className="text-gray-400 text-xs">سبد خرید{cart.items.length !== 0 && ` (${cart.items.length})`}</span>
                </a>
            </Link>
            {user.isLoggedIn && <LogoutModal />}
        </div>
    )
}

function MenuBody({ item }) {
    return (
        <div>
            <button className="no-underline group">
                <span>{item.title}</span>
                <div className="grid grid-cols-5 absolute top-35 inset-x-0 transform origin-top-right bg-white mx-8 px-0.5 py-0.5 rounded shadow-lg z-50 border-right  scale-0 group-hover:show">
                    {item.children.map((category, idx) => (
                        <div key={idx} className="rounded  w-full flex p-2 m-1">
                            <div className="flex flex-col text-center w-full ">
                                <img
                                    src={category.img_path ? `/api/${category.img_path}` : '/img/logo.jpeg'}
                                    className="w-20 rounded-full mb-2 mx-auto"
                                />
                                <Link href={category.href || ''}>
                                    <a className="border-b-2 w-full block p-2 text-purple-500">{category.title}</a>
                                </Link>
                                {category.children && category.children.length !== 0 && (
                                    <ul className="p-2">
                                        {category.children.map((subCategory, idx) => (
                                            <li key={idx}>
                                                <Link href={subCategory.href || ''}>
                                                    <a className="p-2">{subCategory.title}</a>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </button>
        </div>
    )
}

export { NavbarDesktop, NavbarMobile }
